import { UseFormReturnType } from '@mantine/form';
import { RefObject, useRef } from 'react';

import { ActionSettingFormValue } from '#/components/ui/messages/model';

export type ActionSettingRefObject = {
  edit: (
    input: ActionSettingFormValue,
  ) => Promise<ActionSettingFormValue | undefined>;
  value: UseFormReturnType<ActionSettingFormValue>;
};

export type ActionSettingDialogRef = {
  actionSettingRef: RefObject<ActionSettingRefObject | null>;
};

export const useActionSettingDialog = () => {
  const actionSettingRef = useRef<ActionSettingRefObject>(null);

  const edit = async (input: ActionSettingFormValue) => {
    return actionSettingRef?.current?.edit(input);
  };

  return {
    props: { actionSettingRef },
    edit,
  };
};
